<template>
  <nuxt-link
    class="c-swatch-link t-link"
    :title="message"
    :aria-label="message"
    v-bind="$attrs"
  >
    <slot>
      <span
        class="c-swatch-link__swatch-color"
        :style="colorStyle"
      />
      <span class="c-swatch-link__title">{{ message }}</span>
    </slot>
  </nuxt-link>
</template>
<script>
export default {
  props: {
    message: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  },
  computed: {
    colorStyle() {
      if (this.message.includes('Shop All')) {
        return {
          background: 'linear-gradient(180deg, #FF0000 0%, #2AA5CC 100%)'
        }
      } else {
        return {
          backgroundColor: this.color
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-swatch-link {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: rem(36px);
  margin-bottom: rem(10px);

  &__swatch-color {
    width: rem(20px);
    height: rem(20px);
  }

  &__title {
  }
}
</style>